export default __webpack_public_path__ + "static/media/google-play-badge-ar.2aa73507.png";